import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const cleanedBackendUrl = backendUrl.replace("/backend", "");

const AccessRightService = {
  getListAccessRights() {
    return axios.get(`${cleanedBackendUrl}/accessRight`);
  },
  updateAccessRight(accessRights) {
    return axios.put(
      `${cleanedBackendUrl}/accessRight`,
      {
        accessRightList: accessRights
      }
    );
  }
}

export default AccessRightService;